import { observer } from 'mobx-react-lite';
import * as React from 'react';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import type { ITheme } from '@fluentui/style-utilities';
import RequiredAttendeeRow from 'owa-calendar-meeting-forms-common-view/lib/components/Attendees/RequiredAttendeeRow';

import styles from './QuickComposeAttendeeRows.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface QuickComposeAttendeeRowsProps {
    formId: string;
    colorScheme: ColorScheme;
    theme: ITheme;
    showAvailability?: boolean;
    isTimePanelViewType?: boolean;
}

const QuickComposeAttendeeRows: React.FunctionComponent<QuickComposeAttendeeRowsProps> = props => {
    const { formId, colorScheme, theme, showAvailability, isTimePanelViewType } = props;

    return (
        <RequiredAttendeeRow
            colorScheme={colorScheme}
            theme={theme}
            showAvailability={showAvailability}
            iconContainerClassName={styles.quickComposeIcon}
            className={classNames(styles.composeAttendeeRow, {
                isTimePanelViewType,
            })}
            formId={formId}
            wellItemStyles={{
                wellItemText: [
                    {
                        'text-overflow': 'ellipse',
                        'max-width': isTimePanelViewType ? '159px' : '347px',
                    },
                ],
            }}
        />
    );
};

export default observer(QuickComposeAttendeeRows);
